import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { ArticleCard, StoryCard } from "@vfit/shared/components";
var StoryDataContent = function(storiesAndArticles) {
    return storiesAndArticles.map(function(el) {
        var componentProps = {
            title: el === null || el === void 0 ? void 0 : el.title,
            topic: el === null || el === void 0 ? void 0 : el.topic,
            creator: el === null || el === void 0 ? void 0 : el.creator,
            backgroundImg: el === null || el === void 0 ? void 0 : el.backgroundImg,
            ellipseImg: el === null || el === void 0 ? void 0 : el.ellipseImg,
            variant: el === null || el === void 0 ? void 0 : el.variant
        };
        if ((el === null || el === void 0 ? void 0 : el.type) === "story") {
            return /*#__PURE__*/ _jsx(StoryCard, _object_spread({}, componentProps));
        }
        return /*#__PURE__*/ _jsx(ArticleCard, _object_spread({}, componentProps));
    });
};
export default StoryDataContent;
